import React, { Component } from 'react';
import {connect} from 'react-redux';
import update from 'immutability-helper';
import _ from 'lodash';

import {Api} from '../../util';
import Loading from '../../components/loading';
import {Error, UserDetail, UserDelPwd, Notice} from '../../components/modal';
import {showUserFlag, setNotice} from '../../actions';

import NavContainer from './NavContainer';
import SettingContainer from './SettingContainer';

const UserData = [
    // {
    //     id: "USEYN",
    //     title: ""
    // },
    // {
    //     id: "USERCHECK",
    //     title: "userCheck"
    // },
    {
        id: "NUM",
        title: "순번"
    },
    {
        id: "ID",
        title: "아이디"
    },
    // {
    //     id: "PWD",
    //     title: "비밀번호"
    // },
    {
        id: "NAME",
        title: "이름"
    },
    {
        id: "AUTH",
        title: "권한"
    },
    {
        id: "MEMO",
        title: "비고"
    },
    {
        id: "DELYN",
        title: "삭제"
    }
];

const FmtData =[
    {
        id: "NUM",
        title: "순번"
    },
    {
        id: "USEYN",
        title: "사용여부"
    },
    {
        id: "ID",
        title: "포맷ID"
    },
    {
        id: "NAME",
        title: "이름"
    },
    // {
    //     id: "WIDTH",
    //     title: "폭"
    // },
    // {
    //     id: "HEIGHT",
    //     title: "너비"
    // },
    {
        id: "RESOLUTION",
        title: "해상도"
    },
    {
        id: "BITRATE",
        title: "비트레이트 (Kbps)"
    },
    {
        id: "MEMO",
        title: "비고"
    },
    {
        id: "DELYN",
        title: "삭제"
    }
];

const PathData =[
    {
        id: "NUM",
        title: "순번"
    },
    {
        id: "USEYN",
        title: "사용여부"
    },
    {
        id: "ID",
        title: "저장소ID"
    },
    {
        id: "PATHNAME",
        title: "이름"
    },
    {
        id: "TYPE",
        title: "방식"
    },
    {
        id: "HOSTID",
        title: "아이디"
    },
    {
        id: "HOSTPWD",
        title: "비밀번호"
    },
    {
        id: "HOST",
        title: "경로 (UNC: \\\\192.168.0.27\\test, FTP: \\\\192.168.0.26.21)"
    },
    {
        id: "TEST",
        title: "연결시험"
    },
    {
        id: "DELYN",
        title: "삭제"
    }
];

const ChData = [
    {
        id: "NUM",
        title: "순번"
    },
    {
        id: "chName",
        title: "채널명"
    },
    {
        id: "fmtid",
        title: "기본포맷"
    }
]

class Setting extends Component {
    constructor(props){
        super(props);
        this.state = {
            type: 'info-user',
            userData: {},
            userList: [],
            fmtList: [],
            defaultFmtList: [],
            pathList: [],
            defaultPathList: [],
            chList: [],
            loadingFlag: false,
            showError: false,
            userDelFlag: false,
            delUser: '',
            errorContent: ''
        };
        this.listRef = React.createRef();
        this.handleOnTypeModeChange = this.handleOnTypeModeChange.bind(this);
        this.handleOnContent = this.handleOnContent.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.handleUserShow = this.handleUserShow.bind(this);
        this.handleUserHide = this.handleUserHide.bind(this);
        this.handleDelHide = this.handleDelHide.bind(this);
        this.loadingToggle = this.loadingToggle.bind(this);
        
        this.SearchUser = this.SearchUser.bind(this);
        this.DeleteUser = this.DeleteUser.bind(this);
        this.handleOnUserUpdate = this.handleOnUserUpdate.bind(this);
        this.handleUserExUpdate = this.handleUserExUpdate.bind(this)

        this.SearchFmt = this.SearchFmt.bind(this);
        this.handleOnFmtUpdate = this.handleOnFmtUpdate.bind(this);

        this.SearchPath = this.SearchPath.bind(this);
        this.handleOnPathUpdate = this.handleOnPathUpdate.bind(this);
        this.handleOnPathTest = this.handleOnPathTest.bind(this);

        this.SearchCh = this.SearchCh.bind(this);
        this.handleOnChUpdate = this.handleOnChUpdate.bind(this);

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleRowAdd = this.handleRowAdd.bind(this);
    }

    async componentDidMount(){
        // await Promise.all([
        //     this.SearchUser(),
        //     this.SearchFmt(),
        //     this.SearchPath(),
        //     this.SearchCh()
        // ]);
        this.SearchUser();
    }

    // 설정 메뉴 탭
    handleOnTypeModeChange(type){
        this.setState({type});
    }

    // 사용자 검색
    async SearchUser(){
        let userList = [];
        try{
            this.setState({loadingFlag: true});
            const resUser = await Api.SearchUserEx();
            userList = resUser.files.user;
            await this.setState({
                userList
            });
            if(this.listRef.current) this.listRef.current.scrollTop = 0;
        } catch(e) {
            console.log(e, "SearchUser");
        } finally {
            this.setState({
                loadingFlag: false
            });
        }
    }

    // 사용자 삭제
    DeleteUser(userId){
        this.setState({
            userDelFlag: true,
            delUser: userId
        });
        // try{
        //     this.setState({loadingFlag: true});
        //     await Api.DeleteUser({ID: userId});
            
        //     this.props.setNotice(true, 'success', "사용자를 삭제하였습니다");
        //     this.SearchUser();
        // } catch(e) {
        //     console.log(e, "DeleteUser");
        // } finally {
        //     this.setState({
        //         loadingFlag: false
        //     });
        // }
    }
  // 사용자 삭제
  loadingToggle(flag){
    this.setState({
        loadingFlag: flag});
    }
    

    // 사용자설정 중복체크
    warnUserInvalidValue(list){
        const idArr = Object.keys(_.keyBy(list, 'ID'));
        const idCheck = Array.from(new Set(idArr)).length !== list.length;
        for(let i=0; i < list.length; i++){
            // ID 중복체크
            if(idCheck){
                return "중복된 아이디가 존재합니다.";
            }
            // 비밀번호 입력 확인
            else if(!list[i].PWD){
                return "비밀번호가 입력되지 않았습니다.";
            }
            // 이름 입력 확인
            else if(!list[i].NAME){
                return "이름이 입력되지 않았습니다.";
            }
        }
       return '';
    }

    // 사용자 ID 중복검사 확인 후 업데이트
    async handleOnUserUpdate(){
        let list = [];
        const {userList} = this.state;
        if(userList.length > 0){
            list = userList.filter(type => type.DELYN !== 'Y' && type.ID.trim() !== '' );
            delete list.DELYN; // 삭제여부 속성 제거
            delete list.ADDYN; // 행추가여부 속성 제거
            const newList = list.map(field => { // 객체 모든 값 trim 적용
                const newField = {};
                for(const key in field){
                    newField[key] = field[key].trim();
                }
                return newField;
            });
            let msg = this.warnUserInvalidValue(newList); // 중복검사
            if(msg === ''){ 
                try{
                    this.setState({loadingFlag: true});
                    await Api.UpdateUserEx({
                        LIST: newList
                    });
                } catch(e) {
                    this.setState({
                        showError: true,
                        errorContent: e
                    });
                } finally {
                    this.setState({
                        loadingFlag: false
                    });
                    this.SearchUser();
                }
            }
            else{
                alert(msg);
            }
        }
    }
    

    // 포맷 검색
    async SearchFmt(){
        let fmtList = [];
        try{
            this.setState({loadingFlag: true});
            const resFmt = await Api.SearchFmt();
            fmtList = resFmt.files.fmt;
            await this.setState({
                fmtList,
                defaultFmtList: fmtList
            });
            if(this.listRef.current) this.listRef.current.scrollTop = 0;
        } catch(e) {
            console.log(e, "SearchFmt");
        } finally {
            this.setState({
                loadingFlag: false
            });
        }
    }

    // 포맷설정 유효성검사
    warnFmtInvalidValue(list){
        for(let i=0; i < list.length; i++){
            // 폭 입력확인
            if(!list[i].WIDTH){
                return "해상도 폭이 입력되지 않았습니다.";
            }
            // 너비 입력 확인
            else if(!list[i].HEIGHT){
                return "해상도 너비가 입력되지 않았습니다.";
            }
            // 비트레이트 입력 확인
            else if(!list[i].BITRATE){
                return "비트레이트 값이 입력되지 않았습니다.";
            }
        }
       return '';
    }
    // 포맷설정 유효성검사 후 업데이트
    async handleOnFmtUpdate(){
        let list = [];
        const {fmtList, defaultFmtList} = this.state;
        const fmtIDList = _.keyBy(defaultFmtList, 'ID');
        if(fmtList.length > 0){
            // 삭제여부 확인 및 이름 NULL값 확인
            fmtList.map( (data) =>
            {
                if(data.ID !== '' && data.NAME.trim() === '') data.NAME = fmtIDList[data.ID].NAME;
                return data.DELYN !== 'Y' && data.NAME.trim() !== '' && list.push(data);
            });
            delete list.DELYN; // 삭제여부 속성 제거
            const newList = list.map(field => { // 객체 모든 값 trim 적용
                    const newField = {};
                    for(const key in field){
                        newField[key] = field[key].trim();
                    }
                    return newField;
            });
            let msg = this.warnFmtInvalidValue(newList); // 중복검사
            if(msg === ''){ 
                try{
                    this.setState({loadingFlag: true});
                    await Api.UpdateFmt({
                        LIST: newList
                    });
                } catch(e) {
                    this.setState({
                        showError: true,
                        errorContent: e
                    });
                } finally {
                    this.setState({
                        loadingFlag: false
                    });
                    await this.SearchFmt();
                }
            }
            else{
                alert(msg);
            }
        }
    }

    // 저장소 검색
    async SearchPath(){
        let pathList = [];
        try{
            this.setState({loadingFlag: true});
            const resPath = await Api.SearchPath();
            pathList = resPath.files.path;
            await this.setState({
                pathList,
                defaultPathList: pathList
            });
            if(this.listRef.current) this.listRef.current.scrollTop = 0;
        } catch(e) {
            console.log(e, "SearchPath");
        } finally {
            this.setState({
                loadingFlag: false
            });
        }
    }

    // 저장소설정 유효성검사
    warnPathInvalidValue(list){
        for(let i=0; i < list.length; i++){
            // 저장소 호스트 아이디 입력확인
            if(!list[i].HOSTID){
                return "저장소 아이디가 입력되지 않았습니다.";
            }
            // 저장소 비밀번호 입력 확인
            else if(!list[i].HOSTPWD){
                return "저장소 비밀번호가 입력되지 않았습니다.";
            }
            // 경로 입력 확인
            else if(!list[i].HOST){
                return "경로가 입력되지 않았습니다.";
            }
        }
       return '';
    }
    // 저장소설정 유효성검사 후 업데이트
    async handleOnPathUpdate(){
        let list = [];
        const {pathList, defaultPathList} = this.state;
        const pathIDList = _.keyBy(defaultPathList, 'ID');
        if(pathList.length > 0){
            // 삭제여부 확인 및 이름 NULL값 확인
            pathList.map( (data) =>
            {
                if(data.ID !== '' && data.PATHNAME.trim() === '') data.PATHNAME = pathIDList[data.ID].PATHNAME;
                return data.DELYN !== 'Y' && data.PATHNAME.trim() !== '' && list.push(data);
            });
            delete list.DELYN; // 삭제여부 속성 제거
            const newList = list.map(field => { // 객체 모든 값 trim 적용
                    const newField = {};
                    for(const key in field){
                        newField[key] = field[key].trim();
                    }
                    return newField;
            });
            let msg = this.warnPathInvalidValue(newList); // 중복검사
            if(msg === ''){ 
                try{
                    this.setState({loadingFlag: true});
                    await Api.UpdatePath({
                        LIST: newList
                    });
                } catch(e) {
                    this.setState({
                        showError: true,
                        errorContent: e
                    });
                } finally {
                    this.setState({
                        loadingFlag: false
                    });
                    await this.SearchPath();
                }
            }
            else{
                alert(msg);
            }
        }
    }
    // 저장소설정 연결시험
    handleOnPathTest(info){
        const {HOST, HOSTID, HOSTPWD} = info;
        alert(`연결시험 - ${HOST}_${HOSTID}_${HOSTPWD}`);
    }

    // 채널 검색
    async SearchCh(){
        let chList = [];
        try{
            this.setState({loadingFlag: true});
            const resCh = await Api.GetChList();
            chList = resCh.files.ch;
            if(chList instanceof Array) chList = chList.filter(field => field.active === 'Y');
            this.setState({
                chList
            });
        } catch(e) {
            console.log(e, "SearchCh");
        } finally {
            this.setState({
                loadingFlag: false
            });
        }
    }
    // 채널 포맷정보 업데이트
    async handleOnChUpdate(){
        let list = [];
        const {chList} = this.state;
        if(chList.length > 0){
            chList.map(field => {
                return list.push({
                    CHID: field.chId,
                    FMTID: field.fmtid
                });
            });
            try{
                this.setState({loadingFlag: true});
                await Api.UpdateChFmt({
                    LIST: list
                });
            } catch(e) {
                this.setState({
                    showError: true,
                    errorContent: e
                });
            } finally {
                this.setState({
                    loadingFlag: false
                });
                await this.SearchCh();
            }
           
        }
    }

    // 에러 팝업창 닫기
    handleHide(){
        this.setState({
          showError: false
        });
    }


    // 사용자 정보 저장
    async handleUserExUpdate(cmdData){
        try{
            this.setState({loadingFlag: true});
            const res = await Api.UpdateUserEx({
                ...cmdData
            });
            this.props.setNotice(true, 'success', '사용자 정보를 저장하였습니다');
        } catch(e) {
            this.props.setNotice(true, 'fail', '사용자 정보를 저장하는데 실패하였습니다');
            // await this.setState({
            //     showError: true,
            //     errorContent: e
            // });
        } finally {
            this.setState({
                loadingFlag: false
            });
            this.SearchUser();
        }
    }

    // 사용자 편집창 열기
    async handleUserShow(userInfoType, userData={}){
        await this.setState({userData});
        await this.props.showUserFlag(true, userInfoType);
    }

    // 사용자 편집창 닫기
    handleUserHide(){
        this.props.showUserFlag(false);
    }

    handleDelHide(){
        this.setState({userDelFlag: false})
    }

    // 설정관리 행추가
    async handleRowAdd(){
        const userRowAdd = {
            ID: '',
            PWD: '',
            USEYN: '',
            NAME: '',
            MEMO: '',
            AUTH: 'U',
            DELYN: '',
            ADDYN: 'Y'
        };

        const fmtRowAdd = {
            ID: '',
            USEYN: '',
            NAME: '',
            WIDTH: '',
            HEIGHT: '',
            BITRATE: '',
            MEMO: '',
            DELYN: ''
        };

        const pathRowAdd = {
            ID: '',
            USEYN: '',
            PATHNAME: '',
            TYPE: 'U',
            HOST: '',
            HOSTID: '',
            HOSTPWD: '',
            DELYN: ''
        };
        
        await this.setState(prevState => {
            const {type} = this.state;
            switch(type){
                case 'info-user':
                    let userList = prevState.userList;
                    userList.push(userRowAdd);
                    return {userList};
                case 'info-fmt':
                    let fmtList = prevState.fmtList;
                    fmtList.push(fmtRowAdd);
                    return {fmtList};
                case 'info-path':
                    let pathList = prevState.pathList;
                    pathList.push(pathRowAdd);
                    return {pathList};
                default:
                    return;
            }
        });
        if(this.listRef.current) this.listRef.current.scrollTop = this.listRef.current.scrollHeight - this.listRef.current.clientHeight;
    }
    // 설정관리 리스트 수정
    handleOnChange(e, id, idx){
        const {type, userList, fmtList, pathList, chList} = this.state;
        let value = e.target.value;
        let typeList, stateName = userList;
        if(id === 'USEYN' || id === 'DELYN'){ // 사용여부, 삭제여부 checkbox타입
            value = e.target.checked === true ? 'Y' : 'N';
        }
        // if(id === 'WIDTH' || id === 'HEIGHT' || id === 'BITRATE'){ // 숫자 값 입력 확인
        //     const strNum = /^[/'/"/0-9]*$/;
        //     if(!strNum.test(value)){
        //         alert("숫자만 입력해주세요. 특수문자와 한글/영문은 사용할수 없습니다.");
        //         return;
        //     }
        // }

        if(id === 'BITRATE'){ // 숫자 값 입력 확인
            const strNum = /^[/'/"/0-9]*$/;
            if(!strNum.test(value)){
                alert("숫자만 입력해주세요. 특수문자와 한글/영문은 사용할수 없습니다.");
                return;
            }
        }
        let WIDTH = 0, HEIGHT = 0;
        if(id === 'RESOLUTION'){ // 해상도 값 확인
            switch(value){
                case "nHD":
                    WIDTH=640;
                    HEIGHT=360;
                break;
                case "qHD":
                    WIDTH=960;
                    HEIGHT=540;
                break;
                case "HD":
                    WIDTH=1280;
                    HEIGHT=720;
                break;
                case "HD+":
                    WIDTH=1600;
                    HEIGHT=900;
                break;
                case "FHD":
                    WIDTH=1920;
                    HEIGHT=1080;
                break;
                default:
                    WIDTH=640;
                    HEIGHT=360;
                break;
            }
        }
        switch(type){
            case 'info-user':
                typeList = 'userList';
                stateName = userList;
                break;
            case 'info-fmt':
                typeList = 'fmtList';
                stateName = fmtList;
                break;
            case 'info-path':
                typeList = 'pathList';
                stateName = pathList;
                break;
            case 'info-ch':
                typeList = 'chList';
                stateName = chList;
                break;
            default:
                break;
        }
        this.setState( () => 
        {
            let obj = {};
            if(id === 'RESOLUTION'){
                obj = {
                    [typeList]: update(
                        stateName,
                        {[idx]: {
                                "WIDTH": {$set: WIDTH},
                                "HEIGHT": {$set: HEIGHT},
                            }
                        }
                    )
                }
            }else{
                obj = {
                    [typeList]: update(
                        stateName,
                        {[idx]: {[id]: {$set: value}}}
                    )
                }
            }
        return obj;
        });
    }
    

    // 설정관리 리스트 분류
    handleOnContent(){
        const {type, userList, fmtList, pathList, chList} = this.state;
        switch(type){
            case 'info-user':
                const user = {
                    type,
                    headerData: UserData,
                    list: userList,
                    saveOnClick: this.handleOnUserUpdate,
                    refreshOnClick: this.SearchUser,
                    hadnleUserDel:this.DeleteUser,
                    rowAdd: this.handleRowAdd,
                    handleOnChange: this.handleOnChange,
                    handleUserShow: this.handleUserShow,
                    listRef: this.listRef
                };
                return user;
            case 'info-fmt':
                const fmt = {
                    type,
                    headerData: FmtData,
                    list: fmtList,
                    saveOnClick: this.handleOnFmtUpdate,
                    refreshOnClick: this.SearchFmt,
                    rowAdd: this.handleRowAdd,
                    handleOnChange: this.handleOnChange,
                    listRef: this.listRef
                };
                return fmt;
            case 'info-path':
                const path = {
                    type,
                    headerData: PathData,
                    list: pathList,
                    saveOnClick: this.handleOnPathUpdate,
                    refreshOnClick: this.SearchPath,
                    rowAdd: this.handleRowAdd,
                    handleOnChange: this.handleOnChange,
                    handleOnPathTest: this.handleOnPathTest,
                    listRef: this.listRef
                };
                return path;
            case 'info-ch':
                const ch = {
                    type,
                    headerData: ChData,
                    list: chList,
                    fmtList: fmtList,
                    saveOnClick: this.handleOnChUpdate,
                    refreshOnClick: this.SearchCh,
                    handleOnChange: this.handleOnChange
                };
                return ch;
            default:
                const etc = {
                    type,
                    headerData: [],
                    list: [],
                    saveOnClick: this.handleOnUserUpdate,
                    rowAdd: this.handleRowAdd,
                    handleOnChange: this.handleOnChange,
                    listRef: this.listRef
                };
                return etc;
        }
    }

    render() {
        const {display, userFlag, noticeFlag} = this.props;
        const {type, loadingFlag, showError, errorContent, userData, delUser, userDelFlag} = this.state;
        const style = {display: display ? 'flex' : 'none'};
        return (
            <div className='content container setting' style={style}>
                <NavContainer type={type} handleOnTypeModeChange={this.handleOnTypeModeChange} />
                <SettingContainer {...this.handleOnContent()}/>
                {loadingFlag && <Loading />}
                {showError && <Error 
                    handleHide={this.handleHide}
                    errorContent={errorContent} />}
                {userFlag && <UserDetail 
                    userData={userData}
                    handleUserUpdate={this.handleUserExUpdate}
                    handleUserHide={this.handleUserHide} />}
                {userDelFlag && <UserDelPwd 
                    userId={delUser}
                    SearchUser={this.SearchUser}
                    loadingToggle={this.loadingToggle}
                    handleDelHide={this.handleDelHide} />}
                {noticeFlag && <Notice />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
    userFlag: state.userFlag,
    noticeFlag: state.noticeFlag
  }
};

const mapDispatcherToProps = dispatch => {
    return {
        showUserFlag: (userFlag, userInfoType) => dispatch(showUserFlag(userFlag, userInfoType)),
        setNotice: (flag, state, content) => dispatch(setNotice(flag, state, content))
        
    }
  };
  
Setting = connect(mapStateToProps,mapDispatcherToProps)(Setting);
  
export default Setting;


// WEBPACK FOOTER //
// ./src/containers/setting/index.js